import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/global/LoadingSpinner';
import { useAdminData } from '../contexts/AdminDataContext';
import { useTenant } from '../tenancy/TenantContext';
import { addTenantQueryToPath } from '../auth/adminAccess';

interface AdminOnlyProps {
  element: JSX.Element;
}

const AdminOnlyRoute: React.FC<AdminOnlyProps> = ({ element }) => {
  const { user, loading } = useAuth();
  const { tenantId } = useTenant();
  const { currentEmployeeQuery: employeeQuery } = useAdminData();


  if (loading || employeeQuery.isLoading) {
    return <LoadingSpinner />;
  }

  // If no authenticated user, redirect to the admin login page
  if (!user) {
    return <Navigate to={addTenantQueryToPath('/admin', tenantId)} replace />;
  }

  if (employeeQuery.isError || !employeeQuery.data?.admin) {
    return <Navigate to={addTenantQueryToPath('/admin', tenantId)} replace />;
  }

  // If authenticated, render the requested element (e.g., AdminDashboard)
  return element;
};

export default AdminOnlyRoute;
